import { render, staticRenderFns } from "./scoreForm.vue?vue&type=template&id=054c940b&"
import script from "./scoreForm.vue?vue&type=script&lang=js&"
export * from "./scoreForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports